import { QuarantineLogTypeEnum } from '../../../types/log';

export const QUARANTINE_TYPE_NAME_MAP = new Map<QuarantineLogTypeEnum, string>([
  [QuarantineLogTypeEnum.Exchange, 'exchange'],
  [QuarantineLogTypeEnum.SharePoint, 'sharePoint'],
  [QuarantineLogTypeEnum.OneDrive, 'oneDrive'],
  [QuarantineLogTypeEnum.Box, 'box'],
  [QuarantineLogTypeEnum.Gmail, 'gmail'],
  [QuarantineLogTypeEnum.GmailInline, 'gmailInline'],
  [QuarantineLogTypeEnum.Dropbox, 'dropbox'],
  [QuarantineLogTypeEnum.GoogleDrive, 'googleDrive'],
  [QuarantineLogTypeEnum.SalesforceSandbox, 'salesforceSandbox'],
  [QuarantineLogTypeEnum.SalesforceProduction, 'salesforceProduction'],
  [QuarantineLogTypeEnum.Teams, 'teams'],
  [QuarantineLogTypeEnum.ExchangeServer, 'exchangeServer'],
  [QuarantineLogTypeEnum.ExchangeInline, 'exchangeInline'],
]);

export const quarantineConfig: {
  [key in QuarantineLogTypeEnum]: {
    key: QuarantineLogTypeEnum;
    showFields: string[];
    facets: string[];
    searchFields: string[];
    mergedFields: {
      [type: string]: string[];
    };
    wrapFields: string[];
    copyFields: (
      | string
      | {
          from: string;
          to: string;
        }
    )[];
  };
} = {
  exchange: {
    key: QuarantineLogTypeEnum.Exchange,
    showFields: [
      'timestamp',
      'filterType',
      'threatType',
      'mergedSecurityRiskName',
      'orgName',
      'fileStatus',
      'violator',
      'violatedFile',
      'msgSubject',
      'msgFrom',
      'msgTo',
      'quarantineType',
      'errorCode',
      'mailLocation', //TODO
      'messageId',
      'protectionMode',
      'actionSource',
    ],
    facets: [
      'companyGuid',
      'filterType',
      'threatType',
      'violator',
      'fileStatus',
      'protectionMode',
    ],
    searchFields: ['companyGuid', 'all'],
    mergedFields: {
      mergedSecurityRiskName: [
        'blockReason',
        'suspiciousUrl',
        'spamCategory',
        'fbTrueFileType',
        'fileName',
        'urlCategory',
        'raiMatchedRules',
      ],
    },
    copyFields: [
      'ddaaasRiskLevel',
      'actionId',
      'companyGuid',
      'orgName',
      'uniqueId',
      'uniqueLogId',
      'traceId',
      'type',
      'index',
      'id',
      'folderPath',
      'msgReceivedTime',
      'protectionMode',
      'emsTimestamp',
      'emsTraceId',
      'restoreBy',
      'msgDeliveryTime',
      'digestBlobPath',
      {
        from: 'quarantineType',
        to: 'quarantineTypeKey',
      },
      {
        from: 'fileStatus',
        to: 'fileStatusKey',
      },
      {
        from: 'timestamp',
        to: 'timestampKey',
      },
      {
        from: 'filterType',
        to: 'filterTypeKey',
      },
    ],
    wrapFields: [
      'errorCode',
      'mailLocation',
      'msgFrom',
      'msgTo',
      'blockReason',
      'suspiciousUrl',
      'spamCategory',
      'fbTrueFileType',
    ],
  },
  box: {
    key: QuarantineLogTypeEnum.Box,
    searchFields: ['companyGuid', 'all'],
    showFields: [
      'timestamp',
      'filterType',
      'threatType',
      'mergedSecurityRiskName',
      'orgName',
      'fileStatus',
      'violator',
      'fileOriginalPath',
      'fileName',
      'quarantineType',
      'errorCode',
    ],
    facets: [
      'companyGuid',
      'filterType',
      'threatType',
      'violator',
      'fileStatus',
    ],
    mergedFields: {
      mergedSecurityRiskName: [
        'blockReason',
        'suspiciousUrl',
        'spamCategory',
        'fbTrueFileType',
        'fileName',
        'urlCategory',
      ],
    },
    copyFields: [
      'ddaaasRiskLevel',
      'companyGuid',
      'orgName',
      'uniqueId',
      'uniqueLogId',
      'operatorId',
      'violatorId',
      'folderId',
      'resourceId',
      'isShared',
      'shareSetting',
      'rootNodeId',
      {
        from: 'quarantineType',
        to: 'quarantineTypeKey',
      },
      {
        from: 'fileStatus',
        to: 'fileStatusKey',
      },
      {
        from: 'timestamp',
        to: 'timestampKey',
      },
    ],
    wrapFields: ['errorCode', 'blockReason', 'suspiciousUrl', 'fbTrueFileType'],
  },
  dropbox: {
    key: QuarantineLogTypeEnum.Dropbox,
    searchFields: ['companyGuid', 'all'],
    showFields: [
      'timestamp',
      'filterType',
      'threatType',
      'mergedSecurityRiskName',
      'orgName',
      'fileStatus',
      'violator',
      'fileOriginalPath',
      'fileName',
      'quarantineType',
      'errorCode',
    ],
    facets: [
      'companyGuid',
      'filterType',
      'threatType',
      'violator',
      'fileStatus',
    ],
    mergedFields: {
      mergedSecurityRiskName: [
        'blockReason',
        'suspiciousUrl',
        'spamCategory',
        'fbTrueFileType',
        'fileName',
        'urlCategory',
      ],
    },
    wrapFields: ['errorCode', 'blockReason', 'suspiciousUrl', 'fbTrueFileType'],
    copyFields: [
      'ddaaasRiskLevel',
      'companyGuid',
      'orgName',
      'uniqueId',
      'uniqueLogId',
      'operatorId',
      'violatorId',
      'folderId',
      'resourceId',
      'isShared',
      'shareSetting',
      'rootNodeId',
      {
        from: 'quarantineType',
        to: 'quarantineTypeKey',
      },
      {
        from: 'fileStatus',
        to: 'fileStatusKey',
      },
      {
        from: 'timestamp',
        to: 'timestampKey',
      },
    ],
  },
  gmail_inline: {
    key: QuarantineLogTypeEnum.GmailInline,
    showFields: [
      'timestamp',
      'filterType',
      'threatType',
      'mergedSecurityRiskName',
      'orgName',
      'fileStatus',
      'violator',
      'violatedFile',
      'msgSubject',
      'msgFrom',
      'msgTo',
      'quarantineType',
      'errorCode',
      'mailLocation', //TODO
      'messageId',
      'mailDirection',
    ],
    facets: [
      'companyGuid',
      'filterType',
      'threatType',
      'violator',
      'fileStatus',
      'protectionMode',
      'mailDirection',
    ],
    searchFields: ['companyGuid', 'all'],
    mergedFields: {
      mergedSecurityRiskName: [
        'blockReason',
        'suspiciousUrl',
        'spamCategory',
        'fbTrueFileType',
        'fileName',
        'urlCategory',
      ],
    },
    wrapFields: [
      'errorCode',
      'mailLocation', //TODO
      'msgFrom',
      'msgTo',
      'blockReason',
      'suspiciousUrl',
      'spamCategory',
      'fbTrueFileType',
    ],
    copyFields: [
      'ddaaasRiskLevel',
      'actionId',
      'companyGuid',
      'orgName',
      'uniqueId',
      'uniqueLogId',
      'traceId',
      'type',
      'index',
      'id',
      'msgReceivedTime',
      'folderPath',
      'protectionMode',
      'emsTraceId',
      'restoreBy',
      'msgDeliveryTime',
      'blobPath',
      'backupBlobPath',
      'originalMsgTo',
      'digestBlobPath',
      {
        from: 'quarantineType',
        to: 'quarantineTypeKey',
      },
      {
        from: 'fileStatus',
        to: 'fileStatusKey',
      },
      {
        from: 'timestamp',
        to: 'timestampKey',
      },
      {
        from: 'filterType',
        to: 'filterTypeKey',
      },
      {
        from: 'mailDirection',
        to: 'mailDirectionKey',
      },
    ],
  },
  gmail: {
    key: QuarantineLogTypeEnum.Gmail,
    showFields: [
      'timestamp',
      'filterType',
      'threatType',
      'mergedSecurityRiskName',
      'fileStatus',
      'violator',
      'violatedFile',
      'msgSubject',
      'msgFrom',
      'msgTo',
      'quarantineType',
      'errorCode',
      'mailLocation', //TODO
      'actionSource',
      'messageId',
    ],
    facets: ['filterType', 'threatType', 'violator', 'fileStatus'],
    searchFields: ['companyGuid', 'all'],
    mergedFields: {
      mergedSecurityRiskName: [
        'blockReason',
        'suspiciousUrl',
        'spamCategory',
        'fbTrueFileType',
        'fileName',
        'urlCategory',
      ],
    },
    wrapFields: [
      'errorCode',
      'mailLocation', //TODO
      'msgFrom',
      'msgTo',
      'blockReason',
      'suspiciousUrl',
      'spamCategory',
      'fbTrueFileType',
    ],
    copyFields: [
      'ddaaasRiskLevel',
      'companyGuid',
      'orgName',
      'uniqueId',
      'uniqueLogId',
      'traceId',
      'type',
      'index',
      'id',
      'msgReceivedTime',
      'msgDedicatedQuarantineMailbox',
      'digestBlobPath',
      'folderPath',
      'internetMessageId',
      {
        from: 'quarantineType',
        to: 'quarantineTypeKey',
      },
      {
        from: 'fileStatus',
        to: 'fileStatusKey',
      },
      {
        from: 'timestamp',
        to: 'timestampKey',
      },
      {
        from: 'filterType',
        to: 'filterTypeKey',
      },
    ],
  },
  googledrive: {
    key: QuarantineLogTypeEnum.GoogleDrive,
    showFields: [
      'timestamp',
      'filterType',
      'threatType',
      'mergedSecurityRiskName',
      'orgName',
      'fileStatus',
      'violator',
      'fileOriginalPath',
      'fileName',
      'quarantineType',
      'errorCode',
    ],
    facets: [
      'companyGuid',
      'filterType',
      'threatType',
      'violator',
      'fileStatus',
    ],
    searchFields: ['companyGuid', 'all'],
    mergedFields: {
      mergedSecurityRiskName: [
        'blockReason',
        'suspiciousUrl',
        'spamCategory',
        'fbTrueFileType',
        'fileName',
        'urlCategory',
      ],
    },
    wrapFields: ['errorCode', 'blockReason', 'suspiciousUrl', 'fbTrueFileType'],
    copyFields: [
      'ddaaasRiskLevel',
      'companyGuid',
      'orgName',
      'uniqueId',
      'uniqueLogId',
      'operatorId',
      'violatorId',
      'folderId',
      'resourceId',
      'isShared',
      'shareSetting',
      {
        from: 'quarantineType',
        to: 'quarantineTypeKey',
      },
      {
        from: 'fileStatus',
        to: 'fileStatusKey',
      },
      {
        from: 'timestamp',
        to: 'timestampKey',
      },
    ],
  },
  exchange_inline: {
    key: QuarantineLogTypeEnum.ExchangeInline,
    showFields: [
      'timestamp',
      'filterType',
      'threatType',
      'mergedSecurityRiskName',
      'orgName',
      'fileStatus',
      'violator',
      'violatedFile',
      'msgSubject',
      'msgFrom',
      'msgTo',
      'quarantineType',
      'errorCode',
      'mailLocation', //TODO
      'messageId',
      'mailDirection',
    ],
    facets: [
      'companyGuid',
      'filterType',
      'threatType',
      'violator',
      'fileStatus',
      'protectionMode',
      'mailDirection',
    ],
    searchFields: ['companyGuid', 'all'],
    mergedFields: {
      mergedSecurityRiskName: [
        'blockReason',
        'suspiciousUrl',
        'spamCategory',
        'fbTrueFileType',
        'fileName',
        'urlCategory',
      ],
    },
    wrapFields: [
      'errorCode',
      'mailLocation',
      'msgFrom',
      'msgTo',
      'blockReason',
      'suspiciousUrl',
      'spamCategory',
      'fbTrueFileType',
    ],
    copyFields: [
      'ddaaasRiskLevel',
      'actionId', //TODO
      'companyGuid',
      'orgName',
      'uniqueId',
      'uniqueLogId',
      'traceId',
      'type',
      'index',
      'id',
      'msgReceivedTime',
      'protectionMode',
      'emsTraceId',
      'restoreBy',
      'msgDeliveryTime',
      'blobPath',
      'backupBlobPath',
      'originalMsgTo',
      'digestBlobPath', //TODO
      'folderPath',
      {
        from: 'quarantineType',
        to: 'quarantineTypeKey',
      },
      {
        from: 'fileStatus',
        to: 'fileStatusKey',
      },
      {
        from: 'timestamp',
        to: 'timestampKey',
      },
      {
        from: 'filterType',
        to: 'filterTypeKey',
      },
      {
        from: 'mailDirection',
        to: 'mailDirectionKey',
      },
    ],
  },
  onedrive: {
    key: QuarantineLogTypeEnum.OneDrive,
    showFields: [
      'timestamp',
      'filterType',
      'threatType',
      'mergedSecurityRiskName',
      'orgName',
      'fileStatus',
      'violator',
      'siteUrl',
      'fileOriginalPath',
      'fileName',
      'quarantineType',
      'errorCode',
      'dedicatedSite',
    ],
    facets: [
      'companyGuid',
      'filterType',
      'threatType',
      'violator',
      'fileStatus',
    ],
    searchFields: ['companyGuid', 'all'],
    mergedFields: {
      mergedSecurityRiskName: [
        'blockReason',
        'suspiciousUrl',
        'spamCategory',
        'fbTrueFileType',
        'fileName',
        'urlCategory',
      ],
    },
    wrapFields: ['errorCode', 'blockReason', 'suspiciousUrl', 'fbTrueFileType'],
    copyFields: [
      'ddaaasRiskLevel',
      'companyGuid',
      'orgName',
      'uniqueId',
      'uniqueLogId',
      'traceId',
      'type',
      'index',
      'id',

      // important file properties
      'siteUrl',
      'graphSiteId',
      'useSpodtmDelegator',

      'originalDriveId',
      'originalParentId',
      'originalId',
      'fileName',
      'fileOriginalPath',

      'quarantineDriveId',
      'quarantineParentId',
      'quarantineItemId',
      'quarantineFileName',
      'notificationFileId',
      {
        from: 'quarantineType',
        to: 'quarantineTypeKey',
      },
      {
        from: 'fileStatus',
        to: 'fileStatusKey',
      },
      {
        from: 'filterType',
        to: 'filterTypeKey',
      },
      {
        from: 'timestamp',
        to: 'timestampKey',
      },
    ],
  },
  salesforce_production: {
    key: QuarantineLogTypeEnum.SalesforceProduction,
    showFields: [
      'timestamp',
      'filterType',
      'threatType',
      'mergedSecurityRiskName',
      'orgName',
      'fileStatus',
      'violator',
      'fileOriginalPath',
      'fileName',
      'salesforceTypeName',
      'salesforceViolatedFields',
      'quarantineType',
      'errorCode',
    ],
    facets: [
      'companyGuid',
      'filterType',
      'threatType',
      'violator',
      'fileStatus',
    ],
    searchFields: ['companyGuid', 'all'],
    mergedFields: {
      mergedSecurityRiskName: [
        'blockReason',
        'suspiciousUrl',
        'spamCategory',
        'fbTrueFileType',
        'fileName',
        'urlCategory',
      ],
    },
    wrapFields: ['errorCode', 'blockReason', 'suspiciousUrl', 'fbTrueFileType'],
    copyFields: [
      'ddaaasRiskLevel',
      'companyGuid',
      'orgName',
      'uniqueId',
      'uniqueLogId',
      'operatorId',
      'violatorId',
      'folderId',
      'resourceId',
      'isShared',
      'shareSetting',
      'folderPath',
      {
        from: 'quarantineType',
        to: 'quarantineTypeKey',
      },
      {
        from: 'fileStatus',
        to: 'fileStatusKey',
      },
      {
        from: 'scanSource',
        to: 'scanSourceKey',
      },
      {
        from: 'timestamp',
        to: 'timestampKey',
      },
    ],
  },
  salesforce_sandbox: {
    key: QuarantineLogTypeEnum.SalesforceSandbox,
    showFields: [
      'timestamp',
      'filterType',
      'threatType',
      'mergedSecurityRiskName',
      'orgName',
      'fileStatus',
      'violator',
      'fileOriginalPath',
      'fileName',
      'salesforceTypeName',
      'salesforceViolatedFields',
      'quarantineType',
      'errorCode',
    ],
    facets: [
      'companyGuid',
      'filterType',
      'threatType',
      'violator',
      'fileStatus',
    ],
    searchFields: ['companyGuid', 'all'],
    mergedFields: {
      mergedSecurityRiskName: [
        'blockReason',
        'suspiciousUrl',
        'spamCategory',
        'fbTrueFileType',
        'fileName',
        'urlCategory',
      ],
    },
    wrapFields: ['errorCode', 'blockReason', 'suspiciousUrl', 'fbTrueFileType'],
    copyFields: [
      'ddaaasRiskLevel',
      'companyGuid',
      'orgName',
      'uniqueId',
      'uniqueLogId',
      'operatorId',
      'violatorId',
      'folderId',
      'resourceId',
      'isShared',
      'shareSetting',
      'folderPath',
      {
        from: 'quarantineType',
        to: 'quarantineTypeKey',
      },
      {
        from: 'fileStatus',
        to: 'fileStatusKey',
      },
      {
        from: 'scanSource',
        to: 'scanSourceKey',
      },
      {
        from: 'timestamp',
        to: 'timestampKey',
      },
    ],
  },
  sharepoint: {
    key: QuarantineLogTypeEnum.SharePoint,
    showFields: [
      'timestamp',
      'filterType',
      'threatType',
      'mergedSecurityRiskName',
      'orgName',
      'fileStatus',
      'violator',
      'siteUrl',
      'fileOriginalPath',
      'fileName',
      'quarantineType',
      'errorCode',
    ],
    facets: [
      'companyGuid',
      'filterType',
      'threatType',
      'violator',
      'fileStatus',
    ],
    searchFields: ['companyGuid', 'all'],
    mergedFields: {
      mergedSecurityRiskName: [
        'blockReason',
        'suspiciousUrl',
        'spamCategory',
        'fbTrueFileType',
        'fileName',
        'urlCategory',
      ],
    },
    wrapFields: ['errorCode', 'blockReason', 'suspiciousUrl', 'fbTrueFileType'],
    copyFields: [
      'ddaaasRiskLevel',
      'companyGuid',
      'orgName',
      'uniqueId',
      'uniqueLogId',
      'traceId',
      'type',
      'index',
      'id',

      // important file properties
      'siteUrl',
      'graphSiteId',
      'useSpodtmDelegator',

      'originalDriveId',
      'originalParentId',
      'originalId',
      'fileName',
      'fileOriginalPath',

      'quarantineDriveId',
      'quarantineParentId',
      'quarantineItemId',
      'quarantineFileName',
      'notificationFileId',
      {
        from: 'quarantineType',
        to: 'quarantineTypeKey',
      },
      {
        from: 'fileStatus',
        to: 'fileStatusKey',
      },
      {
        from: 'filterType',
        to: 'filterTypeKey',
      },
      {
        from: 'timestamp',
        to: 'timestampKey',
      },
    ],
  },
  exchangeserver: {
    key: QuarantineLogTypeEnum.ExchangeServer,
    showFields: [
      'timestamp',
      'filterType',
      'threatType',
      'mergedSecurityRiskName',
      'orgName',
      'fileStatus',
      'violator',
      'violatedFile',
      'msgSubject',
      'msgFrom',
      'msgTo',
      'quarantineType',
      'errorCode',
      'mailLocation',
      'actionSource',
      'messageId',
      'productServerName',
    ],
    facets: ['companyGuid', 'filterType', 'threatType', 'fileStatus'],
    searchFields: ['companyGuid', 'all'],
    mergedFields: {
      mergedSecurityRiskName: [
        'blockReason',
        'suspiciousUrl',
        'spamCategory',
        'fbTrueFileType',
        'fileName',
        'urlCategory',
      ],
    },
    wrapFields: [
      'errorCode',
      'mailLocation',
      'msgFrom',
      'msgTo',
      'blockReason',
      'suspiciousUrl',
      'spamCategory',
      'fbTrueFileType',
    ],
    copyFields: [
      'ddaaasRiskLevel',
      'companyGuid',
      'orgName',
      'uniqueLogId',
      'type',
      'index',
      'id',
      'msgReceivedTime',
      {
        from: 'quarantineType',
        to: 'quarantineTypeKey',
      },
      {
        from: 'fileStatus',
        to: 'fileStatusKey',
      },
      {
        from: 'timestamp',
        to: 'timestampKey',
      },
      {
        from: 'filterType',
        to: 'filterTypeKey',
      },
    ],
  },
  teams: {
    key: QuarantineLogTypeEnum.Teams,
    showFields: [
      'timestamp',
      'filterType',
      'threatType',
      'mergedSecurityRiskName',
      'orgName',
      'fileStatus',
      'violator',
      'teamsName',
      'siteUrl',
      'fileOriginalPath',
      'fileName',
      'quarantineType',
      'errorCode',
    ],
    facets: [
      'companyGuid',
      'filterType',
      'threatType',
      'violator',
      'fileStatus',
    ],
    searchFields: ['companyGuid', 'all'],
    mergedFields: {
      mergedSecurityRiskName: [
        'blockReason',
        'suspiciousUrl',
        'spamCategory',
        'fbTrueFileType',
        'fileName',
        'urlCategory',
      ],
    },
    wrapFields: ['errorCode', 'blockReason', 'suspiciousUrl', 'fbTrueFileType'],
    copyFields: [
      'ddaaasRiskLevel',
      'companyGuid',
      'orgName',
      'uniqueId',
      'uniqueLogId',
      'traceId',
      'type',
      'index',
      'id',

      // important file properties
      'siteUrl',
      'graphSiteId',
      'useSpodtmDelegator',

      'originalDriveId',
      'originalParentId',
      'originalId',
      'fileName',
      'fileOriginalPath',

      'quarantineDriveId',
      'quarantineParentId',
      'quarantineItemId',
      'quarantineFileName',
      'notificationFileId',
      {
        from: 'quarantineType',
        to: 'quarantineTypeKey',
      },
      {
        from: 'fileStatus',
        to: 'fileStatusKey',
      },
      {
        from: 'filterType',
        to: 'filterTypeKey',
      },
      {
        from: 'timestamp',
        to: 'timestampKey',
      },
    ],
  },
};

//TODO: noNeedShowFields maybe need add tm_merge_field_security_risk_name
// //fix case 7102, if only DLP displayed, hide security risk name column as DLP has no such column
// var _vf = $scope.visualSearch.searchQuery.facets();
// var filter_search_value = '';
// _vf.forEach(function (_item, _index) {
//   Object.keys(_item).forEach(function (facet_field) {
//     if (
//       _item[facet_field] &&
//       $scope.visual_search_value[facet_field] &&
//       $scope.visual_search_value[facet_field].field === 'tm_filter_type'
//     ) {
//       filter_search_value = filter_search_value + _item[facet_field];
//     }
//   });
// });
// if (filter_search_value === 'Data Loss Prevention') {
//   show_field_in_use['tm_merge_field_security_risk_name'] = false;
// }
export const quarantineNoNeedShowFields = ['dedicatedSite'];

export const quarantineNoNeedSortFields = [
  'mergedFieldFoundIn',
  'spamSnapReport',
  'malwareReport',
  'mergedSecurityRiskName',
  'fileSha1',
  'dlpForensicDataContent',
  'restoreReason',
  'mergedFieldFileName',
  'message',
  'userEmail',
  'eventDescription',
  'userDisplayname',
  'fileMetaName',
  'file_meta_parent_folder',
  'riskDescription',
  'event_ids',
  'errorCode',
  'violatedFile',
  'site_url',
  'policy',
  'fileName',
  'msgTo',
  'protectionMode',
  'mailDirection',
];

const indexDisabledFields = [
  'errorMessage',
  'quarantineHistory',
  'mailbox',
  'cass_share_setting',
  'cass_qt_folder_id',
  'cass_quarantined_file_name',
  'cass_file_id',
];

export const quarantineUnsearchableFields = [
  'fileSha1',
  'timestamp',
  'orgName',
  ...indexDisabledFields,
];

export const EnabledRestoreAllQuarantineType = [
  QuarantineLogTypeEnum.SharePoint,
  QuarantineLogTypeEnum.OneDrive,
  QuarantineLogTypeEnum.Exchange,
  QuarantineLogTypeEnum.Teams,
];

export enum OperationTabUrl {
  Quarantine = '/quarantine',
  UserReportedEmails = '/quarantine/euq-feedback',
  RiskAi = '/quarantine/correlated-intelligence',
}

export const allowedFileStatusQuarantineDownload = [
  'Quarantined',
  'RestoreFailure',
  'RestoreAsNewFailure',
  'RestoreSuccess',
  'RestoreAsNewSuccess',
];
